var _circle, _circle2, _circle3, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _circle4, _rect, _rect2, _circle5, _circle6, _path4, _ellipse4, _path5, _ellipse5, _ellipse6, _ellipse7, _circle7, _rect3, _rect4, _circle8, _ellipse8, _path6, _ellipse9, _path7, _path8, _path9, _path0, _path1, _ellipse0, _path10, _path11, _path12, _path13, _circle9, _circle0, _circle1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFaq = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 523 336",
  role: "img",
  artist: "Katerina Limpitsouni",
  source: "https://undraw.co/",
  className: "illustration illustration-faq",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 766.35,
  cy: 561.776,
  r: 43.067,
  transform: "rotate(-45 256.696 829.381)",
  fill: "#2f2e41"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 762.929,
  cy: 551.366,
  r: 14.719,
  transform: "rotate(-12.481 -695.732 1958.117)",
  fill: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 756.966,
  cy: 547.565,
  r: 4.906,
  transform: "rotate(-12.481 -701.695 1954.315)",
  fill: "#3f3d56"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M764.64834,532.6599c-17.61323-.03251-29.97775-3.17854-29.94827-19.13582s14.33174-28.86688,31.945-28.83431,31.86768,12.99488,31.8382,28.95216C798.45372,529.59929,782.26156,532.69241,764.64834,532.6599Z",
  transform: "translate(-338.5 -282)",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M833.85155,568.97444c-5.05211,17.52641-19.80364,29.79509-35.19135,40.21716q-3.22281,2.18327-6.44766,4.266c-.01457.00636-.02957.02-.04432.02649-.10343.06645-.20707.133-.30344.19991-.44372.286-.88759.57222-1.32762.855l.24171.10858s.23735.12621-.02233.02024c-.07728-.03233-.15825-.06136-.23537-.09387-8.93929-3.60536-18.03735-7.4764-24.888-14.23042-7.1065-7.0136-11.25952-18.01413-7.41141-27.228a17.5918,17.5918,0,0,1,1.90481-3.41886c.31214-.44666.64831-.87416.99832-1.29373a18.85591,18.85591,0,0,1,32.3856,5.72979c1.1305-10.52576-7.54879-19.34265-15.90135-25.84822-8.35623-6.50228-17.85125-13.58341-19.46674-24.05074-.90215-5.82388,1.12306-11.46778,4.81224-15.99852.11421-.13766.22827-.27514.3459-.409a27.51849,27.51849,0,0,1,17.68718-9.48885c12.81321-1.33167,25.25927,5.4506,34.56779,14.35941C830.53754,527.0305,839.59482,549.047,833.85155,568.97444Z",
  transform: "translate(-338.5 -282)",
  fill: "#e6e6e6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M809.76735,546.05008a46.77965,46.77965,0,0,1,5.60443,12.36093,40.61967,40.61967,0,0,1,1.404,11.9968,52.04376,52.04376,0,0,1-6.81624,23.68461A74.9024,74.9024,0,0,1,798.6602,609.1916q-3.22281,2.18327-6.44766,4.266c-.01457.00636-.02957.02-.04432.02649-.10343.06645-.20707.133-.30344.19991-.44372.286-.88759.57222-1.32762.855,0,0,.47906.23479.21938.12882-.07728-.03233-.15825-.06136-.23537-.09387a41.40487,41.40487,0,0,0-13.249-35.6508,41.75957,41.75957,0,0,0-17.14558-9.22645c.31214-.44666.64831-.87416.99832-1.29373a43.296,43.296,0,0,1,7.14664,2.70436,42.424,42.424,0,0,1,19.18179,18.49347,43.37384,43.37384,0,0,1,4.72253,23.80133c.36729-.33284.735-.67291,1.09167-1.00976,6.7929-6.33309,12.82634-13.60244,16.90958-21.99189A48.41647,48.41647,0,0,0,815.247,567.493c-.33324-8.65329-3.781-16.66846-8.77294-23.64614a101.34553,101.34553,0,0,0-19.21051-19.79842,115.15792,115.15792,0,0,0-23.89219-14.75057.828.828,0,0,1-.41667-1.06262.7042.7042,0,0,1,.3459-.409.61308.61308,0,0,1,.53243.02261c1.0539.48518,2.10048.977,3.13867,1.49007a116.46492,116.46492,0,0,1,24.06247,15.87266C798.11694,531.25013,804.785,538.14914,809.76735,546.05008Z",
  transform: "translate(-338.5 -282)",
  fill: "#fff"
})), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
  cx: 73.714,
  cy: 331.46,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
})), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 99.881,
  cy: 330.915,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
})), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 469.744,
  cy: 542.424,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-29.963 -226.414 1033.9)",
  fill: "#2f2e41"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 420.936,
  cy: 555.946,
  r: 43.067,
  transform: "rotate(-80.783 85.96 613.876)",
  fill: "#2f2e41"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 62.811,
  y: 307.746,
  width: 13.084,
  height: 23.442,
  fill: "#2f2e41"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 88.978,
  y: 307.746,
  width: 13.084,
  height: 23.442,
  fill: "#2f2e41"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.527,
  cy: 263.043,
  r: 14.719,
  fill: "#fff"
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.527,
  cy: 263.043,
  r: 4.906,
  fill: "#3f3d56"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M379.15975,515.89493c-3.47748-15.57379,7.63867-31.31046,24.82861-35.14884s33.94421,5.67508,37.42169,21.24887-7.91491,21.31766-25.10486,25.156S382.63723,531.46875,379.15975,515.89493Z",
  transform: "translate(-338.5 -282)",
  fill: "#e6e6e6"
})), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 372.428,
  cy: 535.963,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-64.626 -19.75 662.557)",
  fill: "#2f2e41"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M399.78194,571.48328c0,4.21514,10.85327,12.53857,22.89654,12.53857s23.33515-11.867,23.33515-16.08209-11.29193.81775-23.33515.81775S399.78194,567.26813,399.78194,571.48328Z",
  transform: "translate(-338.5 -282)",
  fill: "#fff"
})), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 232.609,
  cy: 331.46,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
})), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 206.441,
  cy: 330.915,
  rx: 10.903,
  ry: 4.089,
  fill: "#2f2e41"
})), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 513.579,
  cy: 542.424,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-60.037 100.294 694.353)",
  fill: "#2f2e41"
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 223.886,
  cy: 273.946,
  r: 43.067,
  fill: "#2f2e41"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 230.428,
  y: 307.746,
  width: 13.084,
  height: 23.442,
  fill: "#2f2e41"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 204.261,
  y: 307.746,
  width: 13.084,
  height: 23.442,
  fill: "#2f2e41"
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 213.796,
  cy: 263.043,
  r: 14.719,
  fill: "#fff"
})), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 545.296,
  cy: 543.043,
  rx: 4.921,
  ry: 4.886,
  transform: "rotate(-44.974 35.426 810.908)",
  fill: "#3f3d56"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M567.01764,527.15094c-17.18994-3.83832-28.58234-9.58219-25.10486-25.156s20.23175-25.08725,37.42169-21.24887,28.3061,19.57505,24.82862,35.14884S584.20758,530.98926,567.01764,527.15094Z",
  transform: "translate(-338.5 -282)",
  fill: "currentColor"
})), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 601.895,
  cy: 567.963,
  rx: 6.76,
  ry: 21.534,
  transform: "rotate(-14.875 -647.49 1723.508)",
  fill: "#2f2e41"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M552.62933,568.75815c-7.90666,0-15.32008-5.03284-15.32008-.81775s7.41338,16.08209,15.32008,16.08209,15.03213-8.32343,15.03213-12.53857S560.536,568.75815,552.62933,568.75815Z",
  transform: "translate(-338.5 -282)",
  fill: "#fff"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M496.97168,484.53906H493.147a12.93742,12.93742,0,0,1-12.92285-12.92285v-3.21094c0-7.95312,1.50684-14.6123,4.479-19.79248a104.11414,104.11414,0,0,1,12.542-16.85156,74.26915,74.26915,0,0,0,8.52783-10.27881,17.29,17.29,0,0,0,2.69336-9.5625c0-7.978-5.19776-11.85644-15.89063-11.85644a64.52587,64.52587,0,0,0-17.51513,2.6289,14.7451,14.7451,0,0,1-18.79248-14.17822v-6.5a14.46343,14.46343,0,0,1,8.53222-13.25635A78.08334,78.08334,0,0,1,496.61035,362.5c11.44434,0,21.77539,1.92236,30.707,5.71289,8.94776,3.79932,16.01709,9.15674,21.01123,15.92383a38.35194,38.35194,0,0,1,7.53614,23.24414c0,8.98-2.45166,16.80127-7.28663,23.24658-4.78222,6.37988-11.63769,13.36426-20.376,20.76026a145.20407,145.20407,0,0,0-13.06348,12.30664,22.71817,22.71817,0,0,0-5.43115,10.11132A12.888,12.888,0,0,1,496.97168,484.53906Z",
  transform: "translate(-338.5 -282)",
  fill: "currentColor"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M494.84521,545.31055h-.50439a23.95118,23.95118,0,0,1,0-47.90235h.50439a23.95118,23.95118,0,1,1,0,47.90235Z",
  transform: "translate(-338.5 -282)",
  fill: "currentColor"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M650.5,618h-311a1,1,0,0,1,0-2h311a1,1,0,0,1,0,2Z",
  transform: "translate(-338.5 -282)",
  fill: "#ccc"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M860.5,618h-166a1,1,0,0,1,0-2h166a1,1,0,0,1,0,2Z",
  transform: "translate(-338.5 -282)",
  fill: "#ccc"
})), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 757.339,
  cy: 582.032,
  rx: 21.534,
  ry: 6.76,
  transform: "rotate(-1.12 -13832.435 17750.767)",
  fill: "#2f2e41"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M746.66142,431h-26a5.00573,5.00573,0,0,1-5-5V400a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,746.66142,431Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V400a3.00328,3.00328,0,0,0-3-3Z",
  transform: "translate(-338.5 -282)",
  fill: "#f2f2f2"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M758.66142,414h-26a5.00573,5.00573,0,0,1-5-5V383a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,758.66142,414Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V383a3.00328,3.00328,0,0,0-3-3Z",
  transform: "translate(-338.5 -282)",
  fill: "#f2f2f2"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M553.66142,331h-26a5.00573,5.00573,0,0,1-5-5V300a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,553.66142,331Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V300a3.00328,3.00328,0,0,0-3-3Z",
  transform: "translate(-338.5 -282)",
  fill: "#f2f2f2"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M537.66142,318h-26a5.00573,5.00573,0,0,1-5-5V287a5.00573,5.00573,0,0,1,5-5h26a5.00573,5.00573,0,0,1,5,5v26A5.00573,5.00573,0,0,1,537.66142,318Zm-26-34a3.00328,3.00328,0,0,0-3,3v26a3.00328,3.00328,0,0,0,3,3h26a3.00328,3.00328,0,0,0,3-3V287a3.00328,3.00328,0,0,0-3-3Z",
  transform: "translate(-338.5 -282)",
  fill: "#f2f2f2"
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 321.22,
  cy: 183.17,
  r: 6.467,
  fill: "#f2f2f2"
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 61.22,
  cy: 160.17,
  r: 6.467,
  fill: "#f2f2f2"
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 497.22,
  cy: 216.17,
  r: 6.467,
  fill: "#f2f2f2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFaq);
export default ForwardRef;